<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"><span class="txit">To my mom, my grandma, and Andre—for your love, patience, and everything else that you’ve given to me over the years.</span></a></p><a id="dedication">
</a><p class="deda"><a id="dedication"></a><a id="pag_vii"><span class="txit">To my papaw—you will be missed.</span></a></p><a id="pag_vii">
</a><p class="deda"><a id="pag_vii"><span class="txit">To all of the fans of Gin and the gang out there—this one’s for you.</span></a><a id="pag_viii"></a></p><a id="pag_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6d7687a7